// Schema for Rentals/Décor/Lighting vendor-type-specific fields.
// Unlike other vendor types, the rental-items section isn't gated behind a
// checkbox here — renting is this vendor type's entire business, so it's
// always shown (rentalItemsGroupFields(null) returns the fields ungated).

import { RENTAL_SERVICES, FOOD_BEVERAGE_ITEMS } from '../constants/vendorOptions';
import { rentalItemsGroupFields } from './fragments/rentalItemsGroup';

export const rentalsSchema = {
  vendorType: 'Rentals/Décor/Lighting',
  fields: [
    {
      type: 'row',
      fields: [
        { key: 'rentalStartingPrice', type: 'price', label: 'Starting Price', optional: true },
        { key: 'rentalAvgPrice', type: 'price', label: 'Average Price', optional: true },
      ],
    },
    { key: 'rentalServices', type: 'chips', label: 'Services', options: RENTAL_SERVICES, optional: true },
    ...rentalItemsGroupFields(null),
    { key: 'foodBeverageItems', type: 'chips', label: 'Food & Beverage Items', options: FOOD_BEVERAGE_ITEMS, optional: true },
  ],
  priceValidations: [
    { startingKey: 'rentalStartingPrice', avgKey: 'rentalAvgPrice' },
  ],
};